module.exports = __webpack_public_path__ + "static/media/food.770160aa.svg";